import script from "./UdcBarGraph.vue?vue&type=script&setup=true&lang=ts"
export * from "./UdcBarGraph.vue?vue&type=script&setup=true&lang=ts"

import "./UdcBarGraph.vue?vue&type=style&index=0&id=c72d05d4&lang=sass&scoped=true"

import exportComponent from "/home/ec2-user/environment/test_front/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c72d05d4"]])

export default __exports__